import Modal from '../../Modal/Modal';
import FormGroup from '../../FormGroup/FormGroup';
import RadioButtonGroup from '../../RadioButtonGroup/RadioButtonGroup';
import React from 'react';
import PromiseButton from '../../PromiseButton';

interface DownloadProps {
    onDownload: (downloadAsFragmented: boolean, latestReleased: boolean) => Promise<void>;
    onClose: () => void;
    isOpen: boolean;
    showVersionSelection: boolean;
}

enum DownloadType {
    full = 'Full',
    fragmented = 'Fragmented'
}

enum ConfigVersion {
    released = 'released',
    current = 'current'
}

interface DownloadState {
    downloadType: string;
    configVersion: ConfigVersion;
}

const fullDescription = 'Description: The full config will be downloaded in an excel file containing separate tabs for each module';
const fragmentedDescription = 'Description: The full config can be downloaded in .zip format where each tab will be in a .csv file.';

class DownloadModal extends React.Component<DownloadProps, DownloadState> {
    constructor(props: any) {
        super(props);

        this.state = {
            downloadType: DownloadType.full.toString(),
            configVersion: ConfigVersion.current
        }
    }

    render(): JSX.Element {
        return (
            <Modal state={{ isOpen: this.props.isOpen, title: 'Download', error: '' }} close={this.props.onClose}>
                <FormGroup label='' isVertical={true}>
                    <RadioButtonGroup
                        key={1}
                        options={[{ text: 'Full Config (.xslx)', value: DownloadType.full }, { text: 'Fragmented Config (.zip)', value: DownloadType.fragmented }]}
                        value={this.state.downloadType}
                        name='1'
                        onChange={(value) => {
                            this.setState({
                                downloadType: value === DownloadType.full ? DownloadType.full.toString() : DownloadType.fragmented.toString()
                            });
                        }}
                        labelClassName='display-inline-flex'
                        className='margin-bottom-10px'
                    />
                    {this.props.showVersionSelection &&
                        <RadioButtonGroup
                            key={2}
                            options={[{ text: 'Current version', value: ConfigVersion.current }, { text: 'Latest released', value: ConfigVersion.released }]}
                            value={this.state.configVersion}
                            name='2'
                            onChange={(value) => {
                                this.setState({
                                    configVersion: value === ConfigVersion.current ? ConfigVersion.current : ConfigVersion.released
                                });
                            }}
                            labelClassName='display-inline-flex'
                            className='margin-bottom-10px'
                        />
                    }
                    <p>{this.state.downloadType === DownloadType.full ? fullDescription : fragmentedDescription}</p>
                    <PromiseButton className='btn cb-btn' enableOnErrorOnly={false} task={async() => { this.props.onDownload(this.state.downloadType === DownloadType.fragmented, this.state.configVersion === ConfigVersion.released); }}>Download</PromiseButton>
                </FormGroup>
            </Modal>
        );
    }
}

export default DownloadModal;
